import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouterLink} from 'react-router-dom'
import {Box, Flex, Img, Text, useBreakpointValue, useStyleConfig} from '@chakra-ui/react'
import CurrentPrice from '../../../display-price/current-price'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import useProductData from '../../../../hooks/use-product-data'
import OmnibusPrice from '../../../display-price/omnibus-price'

const ProductBox = ({product, imageClass, flexDirectionRow = false}) => {
    const styles = useStyleConfig('ProductMoodboard')

    const viewType = useBreakpointValue({base: 'small', lg: 'medium'})

    const {locale} = useMultiSite()

    const images = product?.imageGroups?.find((group) => group.viewType == viewType)?.images
    const image = images && images?.length > 0 ? images[0] : {}

    const {priceData} = useProductData(product || {})
    return (
        <Flex
            direction={flexDirectionRow ? 'row' : 'column'}
            data-testid="product-box"
            as={RouterLink}
            to={
                locale?.alias
                    ? `/${locale.alias}/p/${product?.id ? product?.id + '.html' : '#'}`
                    : '#'
            }
            {...styles.greybox}
        >
            {image?.link && (
                <Box {...styles.imagecontainer} className={'img-container'}>
                    <Img
                        src={image?.link || ''}
                        alt={image?.alt || ''}
                        className={imageClass}
                        {...styles.image}
                    />
                    <Box {...styles.imageoverlay} />
                </Box>
            )}
            <Flex w={flexDirectionRow ? '50%' : 'inherit'} {...styles.textbox}>
                {product?.id && <Text {...styles.productId}>{product?.id}</Text>}
                {product?.name && <Text {...styles.productName}>{product?.name}</Text>}
                {product?.price && product?.currency && (
                    <CurrentPrice
                        price={product?.price}
                        currency={product?.currency}
                        {...styles.price}
                    />
                )}
                {(priceData?.showOmnibusPrice || priceData?.showOmnibusPriceDiscount) &&
                    product?.currency && (
                        <Flex {...styles.omnibusPrice}>
                            <OmnibusPrice
                                priceData={priceData}
                                currency={product?.currency}
                                omnibusExpandedView={false}
                                showDiscount={true}
                                variant={'recommended'}
                            />
                        </Flex>
                    )}
            </Flex>
        </Flex>
    )
}

ProductBox.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        imageGroups: PropTypes.arrayOf(PropTypes.shape()),
        currency: PropTypes.string,
        price: PropTypes.number,
    }),
    imageClass: PropTypes.string,
    flexDirectionRow: PropTypes.bool,
}

export default ProductBox
